import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { truncate } from '../util';

class Component extends BaseComponent {
    componentWillMount() {
        this.props.requireDaily();
    }

    render({ tcod, logged_in }) {
        const tcod_body = tcod && tcod.interp_body ? truncate(tcod.interp_body, 185) : null;


        const user_link = (!/m\./.test(location.href) && !this.props.logged_in)
            ? '#signup'
            : '/daily-tarot-card';

        if (tcod) {
            return (
                <mini-tcod>
                    <h1>Tarot Card of the Day</h1>
                    <ul>
                        <li class={!logged_in ? 'active' : ''}>
                            <a href='/daily-tarot-card'>
                                FOR EVERYONE
                            </a>
                        </li>
                        <li class={logged_in ? 'active' : ''}>
                            <a href={user_link}>
                                FOR YOU
                            </a>
                        </li>
                    </ul>
                    <div class='tcod-main'>
                        {this.renderFigure()}
                        <figcaption>
                            <a href={`/tarot/decks/${tcod.deck.slug}`}>{tcod.deck.name}</a> deck
                            {tcod.deck.deck_vendor_copyright}
                        </figcaption>
                        {this.renderCard(tcod_body)}
                    </div>
                </mini-tcod>
            );
        }

        return (
            <mini-tcod />
        );
    }

    renderFigure = () => {
        const tcod = this.props.tcod;

        if (tcod && tcod.card && tcod.card.name && tcod.card.images && tcod.card.images.full) {
            return (
                <figure>
                    <img src={tcod.card.images.full} alt={tcod.card.name} />
                </figure>
            );
        }

        return null;
    }

    renderCard = (tcod_body) => {
        const tcod = this.props.tcod;

        if (tcod_body && tcod && tcod.card) {
            return (
                <div class='tarot-otd-content'>
                    <section>
                        <time dateTime={Date()}>{`${this.props.pretty_date}, ${new Date().getFullYear()}`}</time>
                        <a class='text-link-undecorated widget-link' href='/daily-tarot-card'>
                            <h2>Tarot Card of the Day</h2>
                            <h3>{tcod.card.name}: </h3>
                            <p>{tcod_body}</p>
                            <span class='text-link'>read more</span>
                            <p class='caption'>
                                {tcod.deck.name} deck {tcod.deck.deck_vendor_copyright}
                            </p>
                        </a>
                    </section>
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    logged_in: state['daily-updates'] && state['daily-updates'].logged_in,
    pretty_date: state['daily-updates'] && state['daily-updates'].pretty_date,
    tcod: state['daily-updates'] && state['daily-updates'].tcod,
});

const mapDispatchToProps = (dispatch) => ({
    requireDaily: () => dispatch({ type: 'daily-updates:required' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/mini-tcod.js